import Axios from 'axios'
import FormatRefFriendObject from "./helpers/formatRefFriendObject"
import { stateMerge } from "vue-object-merge"

const FriendStore = {
    namespaced: true,
    state: {
        status: '',
        friend_jwt: localStorage.getItem('friend_jwt') || '',
        friend_ref_id: localStorage.getItem('friend_ref_id') || '',
        friendRef: {}
    },
    mutations: {
        auth_request(state){
            state.status = 'loading'
        },
        auth_success(state, loginData){
            state.friend_jwt = loginData.jwt
            state.friend_ref_id = loginData.sight_ref_friend.id
            setTimeout(function(){ state.status = 'success' }, 1000);
        },
        auth_error(state){
            state.status = 'error'
        },
        getFriendRef(state, surveyData){
            state.friendRef = surveyData
        },
        updateFriendRefData(state, FriendRefData){
            stateMerge(state.friendRef, FriendRefData)
        }
    },
    actions: {
        login: login,
        getFriendRef: getFriendRef,
        saveFriendRef: saveFriendRef
        // saveEval: saveEval
    }
}


function saveFriendRef(context, surveyData){
    setFriendJwt()
    const formatedRef = FormatRefFriendObject(context.state.friendRef)
    return Axios.put(`${this.sightApiBaseUrl}sight_ref_friends/${context.state.friendRef.id}`, {sight_ref_friend: formatedRef}).then(resp => {
        context.commit('updateFriendRefData', {completed: true})
        return resp
    }).catch(err => {
        console.log("FriendStore/Index error", err)
    })
}

function getFriendRef(context, sightRefFriendId){
    setFriendJwt()
    Axios.get(`${this.sightApiBaseUrl}sight_ref_friends/${sightRefFriendId}/edit/`).then(resp => {
        context.commit('getFriendRef', resp.data)
    }).catch(err => {
        console.log("FriendStore/getFriendRef error", err)
    })
}

function login(context, guestToken){

    context.commit('auth_request')

    const data = {
        guest_token: guestToken,
        guest_type: 'friend',
        client_id: process.env.VUE_APP_AXIOS_API_ID,
        api_secret: process.env.VUE_APP_AXIOS_API_SECRET
    }
    Axios.post(`iapp_api/${process.env.VUE_APP_AXIOS_API_ID}/v1/auth/`, data).then(resp => {

        console.log("Auth success", resp)
        const jwt = resp.data.jwt
        const sight_ref_friend = resp.data.sight_ref_friend

        localStorage.setItem('friend_jwt', jwt)
        localStorage.setItem('sight_ref_friend', sight_ref_friend)
        // localStorage.setItem('evaluation', JSON.stringify(evaluation))

        Axios.defaults.headers.common['Authorization'] = jwt

        context.commit('auth_success', resp.data)

    }).catch(err => {
        console.log("Auth failure", err)
        context.commit('auth_error')
        localStorage.removeItem('friend_jwt')
        localStorage.removeItem('sight_ref_friend')
        // localStorage.removeItem('evaluation')
    })


}

function setFriendJwt(){
    // Set JWT if present
    const jwt = localStorage.getItem('friend_jwt')
    if (jwt) { Axios.defaults.headers.common['Authorization'] = "Bearer " + jwt }
}

export default FriendStore